// src/data/content.js

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  // { label: 'Solutions', href: '#solutions' },
  // { label: 'Why Us', href: '#why' },
  { label: 'Contact', href: '#contact' },
];

export const ABOUT_CARDS = [
  { icon: '🏭', title: 'Industrial Focus', desc: 'Deep expertise in manufacturing, energy, and process industries.' },
  { icon: '🤖', title: 'AI-Native', desc: 'ML and deep learning built into every product we ship.' },
  { icon: '📡', title: 'IoT First', desc: 'Hardware-to-cloud connectivity without compromise.' },
  { icon: '🔒', title: 'Secure by Design', desc: 'Enterprise-grade security baked into the architecture.' },
];

export const ABOUT_PILLS = [
  'Industry 4.0', 'Machine Learning', 'Edge Computing',
  'SCADA & PLC', 'Process Automation', 'Sensor Fusion',
];

export const SERVICES = [
  { icon: '🤖', color: 'rgba(59,130,246,0.15)', title: 'AI & Machine Learning', desc: 'Custom models trained on your operational data — for anomaly detection, process optimization, and intelligent decision support.', tag: 'Core Capability' },
  { icon: '📡', color: 'rgba(6,182,212,0.15)', title: 'IoT Integration', desc: 'End-to-end connectivity from sensors and PLCs to cloud dashboards, supporting all major industrial protocols.', tag: 'Infrastructure' },
  { icon: '🔧', color: 'rgba(16,185,129,0.15)', title: 'Predictive Maintenance', desc: 'Reduce unplanned downtime with continuous asset health monitoring and AI-driven failure predictions.', tag: 'Reliability' },
  { icon: '🌐', color: 'rgba(139,92,246,0.15)', title: 'Digital Twin', desc: 'Virtual replicas of your physical systems — updated in real time, ready for simulation and remote monitoring.', tag: 'Simulation' },
  { icon: '⚡', color: 'rgba(245,158,11,0.15)', title: 'Industrial Automation', desc: 'Smart automation layers that adapt, learn, and improve — from production scheduling to quality checks.', tag: 'Efficiency' },
  { icon: '📊', color: 'rgba(239,68,68,0.15)', title: 'Smart Monitoring', desc: 'Dashboards and alerting systems that give your operations team exactly the right information at the right time.', tag: 'Visibility' },
];

export const SOLUTIONS = [
  {
    icon: '🏭', title: 'Factory Intelligence Platform',
    desc: 'A central intelligence system that integrates with your existing machines, PLCs, and sensors to deliver real-time operational awareness. Built on a modular AI architecture, it learns from your production patterns and surfaces insights that drive smarter decisions — from the shop floor to the boardroom.',
    feats: ['Real-time data ingestion from all machine types', 'Customizable AI models per process', 'OEE and performance tracking', 'Works with legacy and modern equipment'],
  },
  {
    icon: '🔧', title: 'Predictive Maintenance Engine',
    desc: 'An intelligent maintenance layer that continuously analyzes sensor data, vibration, temperature, and usage patterns to predict failures before they happen. Reduce unplanned downtime, extend asset life, and schedule maintenance on your terms — not in response to breakdowns.',
    feats: ['Multi-sensor anomaly detection', 'Failure probability scoring', 'Maintenance scheduling alerts', 'Root cause analysis tools'],
  },
  {
    icon: '🌐', title: 'Digital Twin Environment',
    desc: 'Create a living, breathing virtual replica of your plant or process. Synchronized in real time with physical assets, the digital twin lets you simulate changes, run what-if scenarios, and monitor the actual state of equipment — all without touching the physical system.',
    feats: ['Real-time sync with physical assets', '3D visualization of process states', 'Simulation and scenario modeling', 'Remote monitoring and control'],
  },
  {
    icon: '📡', title: 'IoT Edge-to-Cloud Stack',
    desc: 'A complete, production-ready IoT infrastructure that handles everything from edge device onboarding to cloud analytics. Designed for reliability in harsh industrial environments, with low-latency processing at the edge and rich analytics in the cloud.',
    feats: ['Edge compute with offline resilience', 'Protocol support: MQTT, OPC-UA, Modbus', 'Scalable cloud data pipelines', 'Device management and OTA updates'],
  },
  {
    icon: '🔍', title: 'Smart Quality Control',
    desc: 'AI-powered visual inspection systems that identify defects, deviations, and anomalies in production with speed and precision that surpasses manual inspection. Deployable on existing camera hardware with minimal infrastructure changes.',
    feats: ['Computer vision defect detection', 'Configurable acceptance thresholds', 'Rejection and tracking workflows', 'Continuous model retraining'],
  },
];

export const WHY_CARDS = [
  { num: '01', title: 'Deep Industrial DNA', desc: 'We don\'t just build software - we understand factory floors, plant operations, and the real constraints of industrial environments.' },
  { num: '02', title: 'Outcome-Driven Delivery', desc: 'Every engagement is scoped around measurable results: uptime, throughput, cost, quality. We\'re accountable to the numbers.' },
  { num: '03', title: 'Rapid Time-to-Value', desc: 'Our modular platform lets us deploy working solutions in weeks, not months - with full integration into your existing systems.' },
  { num: '04', title: 'Edge-to-Cloud Architecture', desc: 'Purpose-built for industrial environments where connectivity is intermittent and latency is critical. Your data, your control.' },
  { num: '05', title: 'Scalable by Design', desc: 'Start small with a focused pilot. Scale across your entire operation without rebuilding from scratch.' },
  { num: '06', title: 'Transparent Partnership', desc: 'We work alongside your team - not above them. Knowledge transfer and collaboration are part of every engagement.' },
];

export const CONTACT_TILES = [
  // {
  //   id: 'whatsapp',
  //   icon: '💬',
  //   label: 'WhatsApp',
  //   value: '+91 98765 43210',
  //   sub: 'Chat with us directly',
  //   href: 'https://wa.me/919876543210',
  //   accent: '#25d366',
  //   accentDim: 'rgba(37,211,102,0.1)',
  // },
  {
    id: 'email',
    icon: '✉',
    label: 'Email',
    value: 'gnsingh@aigavindia.com',
    sub: 'We reply within 24 hours',
    href: 'mailto:gnsingh@aigavindia.com',
    accent: '#3b82f6',
    accentDim: 'rgba(59,130,246,0.1)',
  },
  {
    id: 'phone',
    icon: '📞',
    label: 'Phone',
    value: '+91 97176 46425',
    sub: 'Mon – Fri, 9am – 6pm IST',
    href: 'tel:+919717646425',
    accent: '#06b6d4',
    accentDim: 'rgba(6,182,212,0.1)',
  },
];

export const FOOTER_LINKS = {
  Company: [
    { label: 'Home', href: '#home' },
    { label: 'About Us', href: '#about' },
    // { label: 'Why Us', href: '#why' },
    { label: 'Contact', href: '#contact' },
  ],
  Services: [
    { label: 'AI Solutions', href: '#services' },
    { label: 'IoT Integration', href: '#services' },
    { label: 'Predictive Maintenance', href: '#services' },
    { label: 'Digital Twin', href: '#services' },
    { label: 'Smart Monitoring', href: '#services' },
  ],
  // 'Focus Areas': [
  //   { label: 'Industry 4.0', href: '#solutions' },
  //   { label: 'Machine Learning', href: '#solutions' },
  //   { label: 'Edge Computing', href: '#solutions' },
  //   { label: 'SCADA & PLC', href: '#solutions' },
  //   { label: 'Process Automation', href: '#solutions' },
  // ],
};

export const HERO_TAGS = [
  'Industry 4.0', 'Predictive Maintenance', 'Digital Twin',
  'Edge Computing', 'SCADA Integration', 'Computer Vision',
  'Process Automation', 'Real-Time Analytics',
];

// Uncomment solutions and why us sections in navbar and footer when ready to deploy those sections
// export const SECTIONS = ['home', 'about', 'services', 'solutions', 'why', 'contact'];
export const SECTIONS = ['home', 'about', 'services', 'contact'];
